<router-outlet />
<app-loader />
<cve-ui-toast [breakpoint]="breakpoint || 'desktop'" />

<!--
 These components are from the cve-ui library and are optional
 ---------------------------------------
 It is necessary to inject the service into the component you want to use
 to be able to show/hide the loader
 
<cve-ui-loader></cve-ui-loader>

---------------------
It is necessary to inject the service in the component you want to use
to be able to show/hide the toast.

<cve-ui-toast [breakpoint]="'desktop-large'"></cve-ui-toast>

To handle breakpoints, there is a service called breakpoint.service
that is available in the base component and returns the current breakpoint.
All breakpoints are available in the custom-breakpoints.ts file.
-->
